module.exports = "/static/assets/5ebcdae84c8e628c0cdc4c7dc9ca7326.png";